import { render, staticRenderFns } from "./AboutDesign.vue?vue&type=template&id=fcfa9f0c&"
import script from "./AboutDesign.vue?vue&type=script&lang=ts&"
export * from "./AboutDesign.vue?vue&type=script&lang=ts&"
import style0 from "./AboutDesign.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports